// import isMobile from 'ismobilejs';

/**
 * 检查目标版本和当前版本的关系
 * @param {object} params {
 *  version: 'x.x.x', // 目标版本，必须填写3位版本号
 *  operator: 'gt' // 大于：gt； 小于：lt； 等于：eq
 * }
 */
export default function (params) {
    const { version, operator } = params;
    const ua = navigator.userAgent;
    // 获取当前QQ版本的正则
    let REGEXP_QQ = /\bQQ\/([\d.]+)/;
    // if (isMobile(ua).apple.phone) {
    //     REGEXP_QQ = /\bQidian\/([\d.]+)/;
    // }
    const currentVersion = ua.match(REGEXP_QQ);
    const versionArr = version.split('.');
    let flag = false;
    if (currentVersion) {
        const currentVersionArr = currentVersion[1].split('.');
        let forContinue = true;
        versionArr.forEach((val, index) => {
            if (forContinue) {
                if (operator === 'gt') {
                    if (+currentVersionArr[index] < +val) {
                        forContinue = false;
                    }
                    if (+currentVersionArr[index] > +val) {
                        flag = true;
                        forContinue = false;
                    }
                }

                if (operator === 'lt') {
                    console.log(currentVersionArr[index], val);
                    if (+currentVersionArr[index] > +val) {
                        forContinue = false;
                    }
                    if (+currentVersionArr[index] < +val) {
                        flag = true;
                        forContinue = false;
                    }
                }

                if (operator === 'eq') {
                    if (+currentVersionArr[index] !== +val) {
                        forContinue = false;
                    }
                }
            }
        });

        // 当所有的内容都是等于才会是true,所以跑完循环forContinue还为false才是等于
        if (operator === 'eq') {
            flag = flag || forContinue;
        }

        console.log('------ checkVersion ------', operator);
        console.log('currentVersionArr:', currentVersionArr, ' | versionArr:', versionArr, ' | result:', flag);
    }
    return flag;
}
